/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  vehicle_group_id: 'vehicle_group.id:in',
  vehicle_type_id: 'vehicle_type.id:in',
  box_type_id: 'box_type.id:in',
  volume_capacity_min: 'box_type.volume_capacity:gte',
  volume_capacity_max: 'box_type.volume_capacity:lte',
  weight_capacity_min: 'box_type.weight_capacity:gte',
  weight_capacity_max: 'box_type.weight_capacity:lte',
  product_category: 'product_category_id:in',
}

export default parseFilterDataMapping
